define(['lodash', 'santa-components'],
    function (_, santaComponents) {
        'use strict';

        function shouldSetMinWidth(props) {
            return props.componentViewMode === 'editor'; // eslint-disable-line
        }

        const extend = baseClass => {
            class VerticalLinePreviewExtension extends baseClass {
                transformRefData(refData) {
                    if (shouldSetMinWidth(this.props)) {
                        refData['']['data-must-have-min-width'] = true;
                    }
                    return refData;
                }
            }
            VerticalLinePreviewExtension.propTypes = _.defaults({
                componentViewMode: santaComponents.santaTypesDefinitions.RenderFlags.componentViewMode
            }, VerticalLinePreviewExtension.propTypes);
            return VerticalLinePreviewExtension;
        };
        return extend;
    });
